import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BottomDrawerManageService } from './bottom-drawer-manage.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-bottom-drawer',
  templateUrl: './bottom-drawer.component.html',
  styleUrls: ['./bottom-drawer.component.scss']
})
export class BottomDrawerComponent implements OnInit, OnDestroy {

  @ViewChild('drawerContent') drawerContent: TemplateRef<any>;

  @Input() title: string = '';
  @Input() fullscreen: boolean = false;
  @Input() hasBackdrop: boolean = true;
  @Input() showDrawer: EventEmitter<boolean>;

  private isNativeApp: boolean = false;

  private unsub$: Subject<void> = new Subject();

  constructor(private context: BottomDrawerManageService, private platform: Platform) {
    this.isNativeApp = this.platform.is('ios') || this.platform.is('android');
  }

  private get bottomDrawerStyles(): string[] {
    const styles = ['drawer-panel'];
    if (this.fullscreen) styles.push(this.isNativeApp ? 'drawer-panel_fullscreen-native' : 'drawer-panel_fullscreen');
    return styles
  }

  public ngOnInit(): void {
    this.showDrawer?.pipe(takeUntil(this.unsub$)).subscribe(
      (isShow: boolean) => isShow ? this.context.openDrawer(
        this.drawerContent, {
          hasBackdrop: this.hasBackdrop,
          panelClass: this.bottomDrawerStyles,
          backdropClass: 'drawer-backdrop',
          closeOnNavigation: true,
        }
      ) : this.context.closeDrawer()
    );
  }

  public ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }

  public closeDrawer(): void {
    this.context.closeDrawer();
  }
}
